import { Button, ButtonGroup, ButtonIcon } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { PropTypes } from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { approvalInProgressAtom } from '../../atoms/approval';

export function EditButton({
  disabled,
  editing,
  editTitle,
  onEdit,
  saveDisabled,
  onSave,
  isPending,
}) {
  const intl = useIntl();
  const approvalInProgress = useAtomValue(approvalInProgressAtom);

  return !editing ? (
    <ButtonIcon
      icon="Edit"
      title={
        editTitle ||
        intl.formatMessage({
          defaultMessage: 'Edit',
          id: '7dce1',
        })
      }
      disabled={disabled}
      onClick={() => onEdit(true)}
      size="small"
      variant="secondary"
    />
  ) : (
    <ButtonGroup>
      <Button size="small" onClick={() => onEdit(false)} variant="secondary">
        <FormattedMessage defaultMessage="Cancel" id="ea478" />
      </Button>
      <Button
        isDisabled={saveDisabled || approvalInProgress}
        size="small"
        onClick={onSave}
        isPending={isPending}
      >
        <FormattedMessage defaultMessage="Save" id="c9cc8" />
      </Button>
    </ButtonGroup>
  );
}

EditButton.propTypes = {
  disabled: PropTypes.bool,
  editing: PropTypes.bool.isRequired,
  editTitle: PropTypes.string,
  isPending: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saveDisabled: PropTypes.bool.isRequired,
};
EditButton.defaultProps = {
  disabled: false,
  editTitle: undefined,
};

export default { EditButton };
